// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__2cGgl","a-icon":"Loader_a-icon__1hSOz"};